// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EZe_3","title":"styles_title__Nvbbz","description":"styles_description__xTDzu"};